import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter } from "react-router-dom";
import "./global.css";
import "./i18n";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import Clarity from "@microsoft/clarity";

const container = document.getElementById("root");
const root = createRoot(container);

const appInsightsConnStr = import.meta.env
  .VITE_APPLICATION_INSIGHTS_CONNECTIONSTRING;

if (
  appInsightsConnStr !== undefined &&
  appInsightsConnStr !== null &&
  appInsightsConnStr !== ""
) {
  const reactPlugin = new ReactPlugin();
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightsConnStr,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      // Fix (TAPP-982): the app authenticates with bearer tokens and never
      // relies on App Insights cookies (ai_user / ai_session). Disabling them
      // keeps them out of every request to the web host, shrinking the request
      // header baseline that contributes to HTTP 431.
      disableCookiesUsage: true,
    },
  });
  appInsights.loadAppInsights();
}

const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

Clarity.init(clarityProjectId);

// If the user has previously accepted statistics/analysis cookies, grant consent
if (localStorage.getItem("clarity_consent") === "accepted" && window.clarity) {
  window.clarity("consentv2", {
    analytics_Storage: "granted",
    ad_Storage: "denied", // Auto-deny ad storage, no need for it in this app
  });
}

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

serviceWorkerRegistration.register({
  onUpdate: (reg) => {
    try {
      reg.waiting.postMessage({ type: "SKIP_WAITING" });
    } catch (error) {
      console.warn("error", error);
    }
  },
});
